import { ViewFactory } from 'wdc-cube-react'
import PJScope, { HeaderScope } from '../pj.scopes'
import PJView from './pj.view'
import HeaderView from './pj.header'

export function registerViews(rv = ViewFactory.register) {
    rv(PJScope, PJView)
    rv(HeaderScope, HeaderView)
}
